import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import Assessment from "@material-ui/icons/Assessment";
import Info from "@material-ui/icons/Info";
import AppContainer from "../../AppContainer";
import NextEventsCard from "./nextEvents/NextEventsCard";
import LiveEventsCard from "./liveevents/LiveEventsCard";
import EventCardSkeleton from "../EventCardSkeleton";
import {
  getEventDate,
  getUpcomingEvents,
  getLiveEvents,
} from "../../services/eventsUtils";

const PROXIMOS_DIAS = 10;

const getEventsEnProximosDias = (eventsFirebase, dias) => {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  const limite = new Date(hoy);
  limite.setDate(limite.getDate() + dias);
  limite.setHours(23, 59, 59, 999);

  return getUpcomingEvents(eventsFirebase).filter((evento) => {
    const fecha = getEventDate(evento.fechaEvento);
    return fecha && fecha >= hoy && fecha <= limite;
  });
};

const useStyles = makeStyles((theme) => ({
  hero: {
    textAlign: "center",
    marginBottom: theme.spacing(6),
  },
  heroActions: {
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(2),
    flexWrap: "wrap",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    marginBottom: theme.spacing(2),
  },
  section: {
    marginBottom: theme.spacing(6),
  },
  shortcutCard: {
    height: "100%",
  },
  shortcutContent: {
    textAlign: "center",
    padding: theme.spacing(4, 2),
  },
  shortcutIcon: {
    fontSize: 40,
    marginBottom: theme.spacing(1),
  },
}));

const SetTextoInicio = () => {
  const textoInicio = [
    ["Si correr es tu pasión", "Dashport te interesa"],
    ["Si eres activo físicamente", "Dashport te interesa"],
    ["Si crees que todos necesitamos ejercitarnos", "Dashport te interesa"],
    ["Si entrenar te hace feliz", "Dashport te interesa"],
    ["Si adoras las carreras", "Dashport te interesa"],
    ["Si crees que correr crea mejores personas", "Dashport te interesa"],
    ["Si tienes metas deportivas", "Dashport te interesa"],
    ["Si participas en eventos deportivos", "Dashport te interesa"],
    ["Si crees que el ejercicio crea un mundo mejor", "Dashport te interesa"],
    ["Si tu próxima meta se mide en distancia y tiempo", "Dashport te interesa"],
  ];
  return textoInicio[Math.floor(Math.random() * textoInicio.length)];
};

const ACCESOS_RAPIDOS = [
  {
    icon: Assessment,
    titulo: "Resultados",
    to: "/resultados/",
  },
  {
    icon: Info,
    titulo: "Sobre Dashport",
    to: "/servicios/",
  },
];

const Home = () => {
  const classes = useStyles();
  const [titulo, subtitulo] = useMemo(() => SetTextoInicio(), []);

  const eventsFirebase = useSelector((state) => state.events.events);
  const cargandoEventos = eventsFirebase === undefined;
  const eventosEnVivo = useMemo(
    () => getLiveEvents(eventsFirebase),
    [eventsFirebase]
  );
  const proximosEventos = useMemo(
    () => getEventsEnProximosDias(eventsFirebase, PROXIMOS_DIAS),
    [eventsFirebase]
  );

  return (
    <AppContainer showHero>
      <div className={classes.hero}>
        <Typography variant="h3" component="h1" color="primary" gutterBottom>
          {titulo}
        </Typography>
        <Typography variant="h5" component="h2" color="textSecondary">
          {subtitulo}
        </Typography>
        <div className={classes.heroActions}>
          <Button
            variant="contained"
            component={Link}
            to={"/proximos-eventos/"}
            color="primary"
            size="large"
          >
            Próximos eventos
          </Button>
        </div>
      </div>

      {!cargandoEventos && eventosEnVivo.length > 0 && (
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <Typography variant="h5" component="h3">
              Eventos en vivo
            </Typography>
            <Button color="primary" component={Link} to={"/live"}>
              Ver todos
            </Button>
          </div>
          <Grid container spacing={2}>
            {eventosEnVivo.map((evento) => (
              <LiveEventsCard
                key={evento.iDEvento || evento.firebaseKey}
                evento={evento}
              />
            ))}
          </Grid>
        </div>
      )}

      {(cargandoEventos || proximosEventos.length > 0) && (
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <Typography variant="h5" component="h3">
              Próximos eventos
            </Typography>
            <Button color="primary" component={Link} to={"/proximos-eventos/"}>
              Ver todos
            </Button>
          </div>
          <Grid container spacing={2}>
            {cargandoEventos
              ? [1, 2, 3].map((i) => <EventCardSkeleton key={i} />)
              : proximosEventos.map((evento) => (
                  <NextEventsCard
                    key={evento.iDEvento || evento.firebaseKey}
                    evento={evento}
                  />
                ))}
          </Grid>
        </div>
      )}

      <div className={classes.section}>
        <Typography variant="h5" component="h3" gutterBottom>
          Accesos rápidos
        </Typography>
        <Grid container spacing={2}>
          {ACCESOS_RAPIDOS.map(({ icon: Icon, titulo: itemTitulo, to }) => (
            <Grid item xs={12} sm={6} key={to}>
              <Card className={classes.shortcutCard}>
                <CardActionArea component={Link} to={to}>
                  <CardContent className={classes.shortcutContent}>
                    <Icon color="primary" className={classes.shortcutIcon} />
                    <Typography variant="h6">{itemTitulo}</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    </AppContainer>
  );
};

export default Home;
